import * as React from "react";
const SvgPhotos = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 22.84 21.19",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "photos_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "photos_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13.42 12.69a1.75 1.75 0 1 0-1.75-1.75 1.75 1.75 0 0 0 1.75 1.75m0-2.5a.75.75 0 1 1-.75.75.75.75 0 0 1 .75-.75",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M21.06 2.57 5.52 0a2.13 2.13 0 0 0-2.44 1.78l-.56 3.41h-.39A2.13 2.13 0 0 0 0 7.32v11.75a2.12 2.12 0 0 0 2.13 2.12h15.74A2.12 2.12 0 0 0 20 19.07V18a2.1 2.1 0 0 0 .92-1.42L22.82 5a2.13 2.13 0 0 0-1.76-2.43M18 19.07a.12.12 0 0 1-.13.12H2.13a.12.12 0 0 1-.13-.12v-2.45c1.16-1.06 3.88-3.07 5.68-2.48a18 18 0 0 1 1.72.73c2.24 1.05 5 2.32 8.6.22Zm0-6.38c-3.29 2.44-5.46 1.44-7.75.37a17 17 0 0 0-1.93-.81C6.08 11.5 3.61 12.85 2 14V7.32a.13.13 0 0 1 .13-.13h15.74a.13.13 0 0 1 .13.13Zm2-2.85V7.32a2.13 2.13 0 0 0-2.13-2.13H4.55l.5-3.08A.13.13 0 0 1 5.2 2l15.54 2.54a.13.13 0 0 1 .1.15Z",
	style: { fill: "currentColor" }
}))));
export default SvgPhotos;
